import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

function TipRSVPEnvelope() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>3 Things To Remember For RSVP Envelopes</h3>
          <div className="section">
            <p className="desc">
              Keep these pointers in mind when ordering and assembling your RSVP envelopes, and
              you’re guaranteed to receive your guest responses easily, quickly, and without any
              hiccups.
            </p>
          </div>
          <div className="section">
            <p className="head">Include Postage:</p>
            <p className="desc">
              Make sure to include the proper amount of postage on your RSVP envelopes so that
              guests can return them to you easily. Not only is it more convenient and you’ll get a
              better response rate, but it’s polite to take care of this extra task for your guests.
            </p>
          </div>
          <div className="section">
            <p className="head">Address Them:</p>
            <p className="desc">
              Kind of goes without saying, but make sure you address your RSVP envelopes for your
              guests so they can just pop them in the mail. Whether you use Zola’s free addressing
              service or hand-address them yourself, make sure these envelopes are ready to go.
            </p>
          </div>
          <div className="section">
            <p className="head">Send Them To the Right Person:</p>
            <p className="desc">
              You don’t necessarily have to send your RSVP cards back to yourself. If you’ve hired a
              full wedding planner, or if a parent or friend is helping keep track of guests’
              responses for you, then address the RSVP envelopes to that person. Make sure they get
              where they need to go!
            </p>
            <p className="desc">
              For more tips, read more about RSVP envelopes on our{' '}
              <Link
                inline
                href="/expert-advice/invites-paper/wedding-invitations/a-guide-to-wedding-invitation-rsvps/"
                target="_blank"
                rel="noopener noreferrer"
              >
                expert advice
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipRSVPEnvelope;
